module.exports = __webpack_public_path__ + "img/user26.3fc4cdd2.jpg";